export const jwtKeyName = 'staff-jwt';

export function getJwt() {
  return localStorage.getItem(jwtKeyName);
}
